const HomeRoute = {
  path: "/",
  alias: "/home",
  component: () => import("@/components/home/containers/Home"),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "data-sources",
      component: () =>
        import("@/components/organisation/containers/DataSources"),
      children: [
        {
          path: ":id",
          component: () =>
            import("@/components/organisation/containers/DataSourceDetails"),
          meta: {
            title: "Data Source Details",
          },
        },
        {
          path: "",
          component: () =>
            import("@/components/organisation/containers/DataSourceList"),
          meta: {
            title: "Data Sources",
          },
        },
      ],
    },
    {
      path: "new-entity",
      component: () =>
        import("@/components/entities/containers/EntityCreation"),
      meta: {
        title: "Create New Entity",
      },
    },
    {
      path: "entities",
      component: () => import("@/components/entities/containers/EntityParent"),
      children: [
        {
          path: ":entity_id",
          component: () =>
            import("@/components/entities/containers/EntityLookup"),
          meta: {
            title: "Entity Details",
          },
          children: [
            {
              path: "lookup",
              component: () =>
                import("@/components/entities/containers/LookupList"),
            },
            {
              path: "details",
              component: () =>
                import("@/components/entities/containers/EntityDetails"),
            },
            {
              path: "",
              redirect: "lookup",
            },
          ],
        },
        {
          path: "",
          component: () =>
            import("@/components/entities/containers/EntityList"),
          meta: {
            title: "Entities",
          },
        },
      ],
    },
    {
      path: "overview",
      component: () =>
        import("@/components/entity_overview/containers/EntityOverview"),
      meta: {
        title: "Entity overview",
      },
      children: [
        {
          path: ":entity_id/:item_id",
          component: () =>
            import("@/components/entity_overview/containers/OverviewDetails"),
        },
        {
          path: "",
          redirect: "/entities",
        },
      ],
    },
    {
      path: "organisation/:tab?",
      component: () =>
        import("@/components/organisation/containers/Organisation"),
      meta: {
        title: "Organisation",
      },
    },
    {
      path: "dashboards",
      component: () => import("@/components/console/containers/ConsoleList"),
      meta: {
        title: "Consoles",
      },
    },
    {
      path: "settings",
      component: () => import("@/components/settings/containers/Settings"),
      meta: {
        title: "Settings",
      },
    },
    {
      path: "summary",
      component: () => import("@/components/summary/containers/Summary"),
      meta: {
        title: "Locale.ai | Summary",
      },
    },
    {
      path: "",
      redirect: "dashboards",
    },
  ],
};

export default HomeRoute;
